import React from 'react';

import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import {
  Button,
} from '@mui/material';

import AddMeal from '../../../HealthRecord/HealthRecordCategory/Meal/AddMeal';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/** 入力 */
export type LineButtonsInput = {
  /** 日付 */
  date: Date,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const MealButton: React.FC<LineButtonsInput> = ({
  date,
  user,
  child,
  facilityList,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<BabyChangingStationIcon />}
        style={{ marginLeft: 'auto', marginRight: '3px' }}
        onClick={() => setIsOpen(true)}
      >
        食事
      </Button>
      <AddMeal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        child={child}
        user={user}
        facilityList={facilityList}
        date={date}
      />
    </>
  );
};

export default MealButton;
